import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class NAORecStatusTypeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/NAORecStatusTypes`);
    }
}